var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2499.6 2500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f1511b",
    d: "M1187.9 1187.9H0V0h1187.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#80cc28",
    d: "M2499.6 1187.9h-1188V0h1187.9v1187.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00adef",
    d: "M1187.9 2500H0V1312.1h1187.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc09",
    d: "M2499.6 2500h-1188V1312.1h1187.9V2500z"
  })));
};
export default SvgMicrosoft;